export default {fields:{invalidId:{},canRequestAccess:{}}}